import React from 'react';

const AddonsSvg: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M6 0H3V2H1V5H15V2H13V0H10V2H6V0Z" fill="#616061"/>
    <path d="M15 7H1V15H15V7Z" fill="#616061"/>
  </svg>
);

export default AddonsSvg; 